import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import AccordionDetails from '@mui/material/AccordionDetails';
import Item from './Item';

const accordionDetailsStyles = {
  backgroundColor: 'surface.white',
  px: 3,
  py: 0,
};

// namePropOrDashes :: Object -> String
const namePropOrDashes = R.propOr('--', 'name');
const supplierIdOrDashes = R.propOr('--', 'supplierId');

const Unload = ({ compartment }) => {
  const { loadType, supplier, product, volume } = compartment;

  const formattedVolume = R.isEmpty(volume) ? '--' : `${volume} Gallons`;

  return (
    <AccordionDetails sx={accordionDetailsStyles}>
      <Item label="Load Type" value={namePropOrDashes(loadType)} />
      <Item label="Supplier" value={supplierIdOrDashes(supplier)} />
      <Item label="Product" value={namePropOrDashes(product)} />
      <Item label="Volume" value={formattedVolume} />
    </AccordionDetails>
  );
};

Unload.propTypes = {
  compartment: PropTypes.shape({
    loadType: PropTypes.shape({}),
    product: PropTypes.shape({}),
    supplier: PropTypes.shape({}),
    volume: PropTypes.string,
  }).isRequired,
};

export default Unload;
